const PRODUCT_DEFAULT_VAT_PERCENTAGE = 9;

const environment = process.env.NEXT_PUBLIC_ENVIRONMENT;
const isProduction = environment === "production";

const DEFAULT_SHOP_MODE = isProduction ? "live" : "test";

const PRODUCT_TYPE = {
  CITY_CARD: "citycard",
  CANAL_CRUISE: "canalcruise",
};

const PRODUCT_SUBSCRIPTION_TYPE = {
  UITPAS: "uitpas",
};

const SUBSCRIPTION_PAYMENT_INTERVAL_OPTIONS = isProduction
  ? ["monthly", "yearly"]
  : ["daily", "monthly", "yearly"];

const SUBSCRIPTION_DEFAULT_PAYMENT_INTERVAL = "monthly";
const AMSTERDAM_PAS_MINIMUM_AGE = 18;

const SHOP_SHIPPING_OPTIONS = {
  DIGITAL: "Digital",
  DOWNLOAD: "Download",
};

const SHOP_PAYMENT_OPTIONS = {
  VISA: "visa",
  MASTERCARD: "mastercard",
  AMERICAN_EXPRESS: "american-express",
  MAESTRO: "maestro",
  SOFORT: "sofort",
  JCB: "jcb",
  PAYPAL: "paypal",
  IDEAL: "ideal",
};

const SHOP_DEFAULT_PAYMENT_OPTIONS = [
  SHOP_PAYMENT_OPTIONS.IDEAL,
  SHOP_PAYMENT_OPTIONS.VISA,
  SHOP_PAYMENT_OPTIONS.MASTERCARD,
  SHOP_PAYMENT_OPTIONS.AMERICAN_EXPRESS,
  SHOP_PAYMENT_OPTIONS.MAESTRO,
  SHOP_PAYMENT_OPTIONS.PAYPAL,
];

module.exports = {
  PRODUCT_DEFAULT_VAT_PERCENTAGE,
  PRODUCT_TYPE,
  PRODUCT_SUBSCRIPTION_TYPE,
  SUBSCRIPTION_PAYMENT_INTERVAL_OPTIONS,
  SUBSCRIPTION_DEFAULT_PAYMENT_INTERVAL,
  DEFAULT_SHOP_MODE,
  AMSTERDAM_PAS_MINIMUM_AGE,
  SHOP_SHIPPING_OPTIONS,
  SHOP_PAYMENT_OPTIONS,
  SHOP_DEFAULT_PAYMENT_OPTIONS,
};
